const win = 'Win';
const mac = 'Mac';
const linux = 'Linux';

const detectOs = system => navigator.appVersion.indexOf(system) !== -1;

export default detectOs;
export {win, mac, linux};



/** WEBPACK FOOTER **
 ** ./app/scripts/util/detect/detectOS.js
 **/